import { TextShapeType, type ITextLayerProps } from '@/version-types';
import { SHAPE_TEXT_RES_ID } from '../constants';

/**
 * 检查是否为使用变形文字
 *
 * @param layerData - 文字图层数据
 */
export const checkIsUsingShapeText = (layerData: ITextLayerProps) => {
    return !!layerData.shapeExtension;
};

/**
 * 形状类型检测
 */
export const ShapeTypeChecker = {
    /**
     * 检查类型是否为形状变形文字
     *
     * @param type - 文字形状类型
     */
    isWrapEffect: (type: number) => {
        return type >= TextShapeType.waveShaped && type <= TextShapeType.lowerArc;
    },

    /**
     * 检查类型是否为路径变形文字
     *
     * @param type - 文字形状类型
     */
    isPathEffect: (type: number) => {
        return type <= TextShapeType.tilde;
    },
};

/**
 * 获取变形文字配置路径
 *
 * @param type - 文字形状类型
 */
export const getShapeTextPlist = (type: number | string) => {
    return `${SHAPE_TEXT_RES_ID}/${type}/ar/configuration.plist`;
};
